<!--
 * @Author: your name
 * @Date: 2020-12-11 11:16:32
 * @LastEditTime: 2021-03-05 15:51:58
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/tab-admin/tab-history/index.vue
-->
<style scoped lang="sass">
.history_container
  padding-top: 20px

  .empty
    flex: 1
    text-align: center
    color: #909399

  .total_info
    padding: 0 16px

    .total_info_item
      display: flex
      justify-content: space-between
      margin-top: 10px
      font-size: 14px
      color: #334455

.font_bold
  font-weight: bold
</style>

<template lang="pug">
.history_container
  .empty(v-if="!tabDetail.orders.length")
    | No Data
  .content(v-else)
    order-detail(
      v-for="item in tabDetail.orders"
      :key="item.id"
      :order="item"
    )
    .total_info
      .total_info_item
        .total_info_item_title Subtotal:
        .total_info_item_num {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ subtotal | moneyFilters }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
      .total_info_item.font_bold
        .total_info_item_title Total amount:
        .total_info_item_num {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ tabDetail.amount | moneyFilters }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}

  py-loading(:showLoading="loading")
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import OrderDetail from './components/OrderDetail'
import { loading } from 'utils/decorators'
import { getTabDetail } from 'api/tab'
import { formatDecimalNumber, getCurrencySymbol, getSymbolPosition } from '@/utils/currency'

@Component({
  components: {
    OrderDetail
  },

  props: {
    venueId: {
      type: String
    },

    tabId: {
      type: [String, Number]
    }
  },

  computed: {
    subtotal() {
      if (this.tabDetail.orders.length) {
        return this.tabDetail.orders.reduce((total, prev) => total + prev.totalAmount, 0)
      }
      return 0
    },
    currencySymbol() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getCurrencySymbol()
    },
    symbolPosition() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getSymbolPosition()
    }
  },

  filters: {
    moneyFilters(val) {
      if (val) return formatDecimalNumber(Number(val))
      return val
    }
  }
})

class TabHistory extends Vue {
  tabDetail = {
    orders: []
  }

  loading = false

  mounted() {
    this.$store.commit('closeLoading')
    this.getTabDetail()
  }

  get tabPassCode() {
    return this.$store.state.tabPassCode.tabPassCode
  }

  @loading('loading')
  async getTabDetail() {
    this.tabDetail = await this._postTabDetail()
    console.log(this.tabDetail)
  }

  async _postTabDetail() {
    return await getTabDetail({
      venueId: this.venueId,
      tabId: this.tabId,
      passCode: this.tabPassCode,
    }).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
  }
}

export default TabHistory
</script>
